import isTablet from './isTablet';

const isPhone = (): boolean => {
  return /(?:iPhone)/.test(navigator.userAgent) && !isTablet();
};

export default isPhone;
